/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:env
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/27 | 富士通株式会社         | 新規作成
// 01.02.00 | 2022/11/15 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
//================================================================================
 */
export const env = {
	namespaced: true,
	state: {
		listMaxCount: 0,					// 検索中断する一覧件数
		tokubetukojoRojin: 0,				// 特別控除 老人扶養
		tokubetukojoTokutei: 0,				// 特別控除 特定扶養
		tokubetukojoSyogai: 0,				// 特別控除 障害者
		tokubetukojoToksyogai: 0,			// 特別控除 特別障害者
		tokubetukojoKafu: 0,				// 特別控除 寡婦
		tokubetukojoHitorioya: 0,			// 特別控除 ひとり親
		lastAccessTimeUpdateInterval: 0,	// 最終アクセス時間更新間隔（ミリ秒）
	},
    getters: {
		// 検索中断する一覧件数を取得します
		getListMaxCount(state) {
			return state.listMaxCount;
		},
		// 特別控除 老人扶養を取得します
		getTokubetukojoRojin(state) {
			return state.tokubetukojoRojin;
		},
		// 特別控除 特定扶養を取得します
		getTokubetukojoTokutei(state) {
			return state.tokubetukojoTokutei;
		},
		// 特別控除 障害者を取得します
		getTokubetukojoSyogai(state) {
			return state.tokubetukojoSyogai;
		},
		// 特別控除 特別障害者を取得します
		getTokubetukojoToksyogai(state) {
			return state.tokubetukojoToksyogai;
		},
		// 特別控除 寡婦を取得します
		getTokubetukojoKafu(state) {
			return state.tokubetukojoKafu;
		},
		// 特別控除 ひとり親を取得します
		getTokubetukojoHitorioya(state) {
			return state.tokubetukojoHitorioya;
		},
		// 最終アクセス時間更新間隔（ミリ秒）を取得します
		getLastAccessTimeUpdateInterval(state) {
			return state.lastAccessTimeUpdateInterval;
		},
	},
	mutations: {
		// 環境変数を設定します
		setEnvParams(state, params) {
			state.listMaxCount = params.listMaxCount;
			state.tokubetukojoRojin = params.tokubetukojoRojin;
			state.tokubetukojoTokutei = params.tokubetukojoTokutei;
			state.tokubetukojoSyogai = params.tokubetukojoSyogai;
			state.tokubetukojoToksyogai = params.tokubetukojoToksyogai;
			state.tokubetukojoKafu = params.tokubetukojoKafu;
			state.tokubetukojoHitorioya = params.tokubetukojoHitorioya;
			state.lastAccessTimeUpdateInterval = params.lastAccessTimeUpdateInterval;
		},
	},
	actions: {
	},
	modules: {
	}
}